export const formatPriceForDisplay = (price: string): string => {
  // The space between 00 and € MUST be a non-breakable space
  return price.replace(',00 €', ' €').replace('.00 €', ' €');
};
